export const ALL_ROUTE = 'todos';
